import { Component, Vue, Prop, Emit, Mixins } from "vue-property-decorator";
import BASEComponentVue from '@/components/BASEComponentVue';


@Component({
})
export default class OCCheckbox extends Mixins(BASEComponentVue) {

    @Prop({
        type: Boolean,
        default: false,
    })
    public disable!: boolean;

    @Prop({
        type: Boolean,
        default: false,
    })
    public value!: boolean;

    public localValue: boolean = false;

    @Emit("input")
    public input(val: boolean) {
    }

    @Prop({
        type: String,
        required: false,
    })
    public label!: string;

    public created() {
        this.localValue = this.value;
    }

    public boxClick() {
        if (this.disable) return;
        this.localValue = !this.localValue;
        this.$emit("input", this.localValue);
    }

}
